// Because we're using webpack and have configured it to understand `.scss`
// we're able to import this sass file and webpack will output it to a css file
import "./index.scss";
import "bootstrap";
import Popper from 'popper.js';
import "./scripts/dashboard-charts/controllers";
import "./scripts/form";
import "./scripts/survey/survey";
import "./scripts/survey/survey-range";
import "./scripts/nav";
import "./scripts/flatpickr";
//import "./scripts/dashboard-charts/controllers-mocks";
import "./scripts/confirmation";
import Chart from "chart.js";
import "./scripts/toast";
import "./scripts/create-program";
import bsCustomFileInput from 'bs-custom-file-input'; // display file name on input file upload
import "./scripts/program-overview";
import "./scripts/table";
import "./scripts/footer";
import "./scripts/tooltips";
import "./scripts/edit-program";
import "./scripts/dnd-sort";
// popover blurry fix
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;
// tooltip
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});
// popover
$(function () {
    $('[data-toggle="popover"]').popover();
});
// smooth scroll
// smoothscroll
function clickHandler(e) {
    let href = e.currentTarget.getAttribute("href");
    if (href.indexOf("#") === 0) {
        e.preventDefault();
        var { top } = offset(document.querySelector(href));
        var navBottom = 0;
        let top2 = top - navBottom;
        // offset layout sticky header height on application option page
        let layoutHeader = document.querySelector(".layout-header");
        if (layoutHeader) {
            // check if scroll over sticky nav
            top2 = top2 - layoutHeader.offsetHeight;
        }
        // offset layout sticky sub header height on application option page
        let layoutSubHeader = document.querySelector(".layout-sub-header");
        if (layoutSubHeader) {
            // check if scroll over sticky nav
            top2 = top2 - layoutSubHeader.offsetHeight;
        }
        // temporary solution for IE11
        if (isIE()) {
            window.scrollTo(0, top2);
        }
        else {
            window.scrollTo({ top: top2, behavior: "smooth" });
        }
    }
}
[].slice.call(document.querySelectorAll("a[data-smoothscroll]")).forEach(el => {
    el.addEventListener("click", clickHandler);
});
function isIE() {
    return navigator.userAgent.match(/Trident\/7\./);
}
function offset(el) {
    var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var marginTop = parseFloat(window.getComputedStyle(el).marginTop.replace("px", ""));
    return {
        top: rect.top + scrollTop - marginTop,
        left: rect.left + scrollLeft
    };
}
// preload
document.body.classList.remove("preload");
// global chart setting
Chart.defaults.global.defaultFontFamily = '"Rubik", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
// bootstrap file upload
bsCustomFileInput.init();
